// This is just a re-export from the context
// All auth logic is in the AuthContext
export { useAuth } from '@/contexts/AuthContext';
